import { AuthorPageContextValue } from "contexts/new/AuthorPageContext";
import { RoutingContextValue } from "contexts/new/RoutingContext";
import { useEffect } from "react";
import { trackEvent } from "services/frontend/Segment";

export function useRecordAuthorViewed(
  authorPageContext: AuthorPageContextValue,
  routingContext: RoutingContextValue
) {
  useEffect(() => {
    if (authorPageContext.initialized) {
      trackEvent("Author Viewed", {
        author: authorPageContext.fullName,
        referrer: routingContext.referrer,
        previous_page_type: routingContext.referrer_type,
      });
    }
  }, [authorPageContext, routingContext]);
}
